import React from "react";
import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))

`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;
`;

const ClearButton = styled.button
` border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 34px;
  width: 32px;
  border:none;
  border-right:1px solid #aaa;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchButton = styled.button
` border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  border:none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FilterComponent = ({ filterText, onFilter, onClear,onSaveFilter,onFilterText }) => (
  <>
    <Input
      style={{height: "32px",
        width: "200px",
        border: "1px solid #e5e5e5",
        padding: "0 32px 0 16px",
        borderTopLeftRadius: "5px",
  borderBottomLeftRadius: "5px",
  borderTopRightRadius: "0",
  borderBottomRightRadius: "0",
  border: "1px solid #e5e5e5"
      }}
      id="search"
      type="text"
      placeholder="Filter by phone number or vehicle number"
      value={filterText}
       onChange={onSaveFilter}
    />
    <ClearButton style={{
      height: "34px",
      width: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }} onClick={onClear}>X</ClearButton>
     <SearchButton style={{
      height: "34px",
      width: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }} onClick={e=>onFilterText()}><FaSearch></FaSearch></SearchButton>
  </>
);

export default FilterComponent;
